import { useContext } from "react";
import { Alert, Box, Button, Stack } from "@mui/material";
import { UserInfoContext } from "./contexts/UserInfoContext";
import splineLogo from "./images/spline_color_knockout_logo.png";

function OrganizationExpired() {
  const { onLogout } = useContext(UserInfoContext);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      sx={{ width: "100%", height: "100vh" }}
    >
      <Stack
        direction="column"
        alignItems="center"
        justifyContent="center"
        spacing={5}
        sx={{ width: "400px" }}
      >
        <Box component={"img"} src={splineLogo} sx={{ width: "90%" }} />
        <Alert severity="error" sx={{ width: "100%" }}>
          Your company's subscription has expired. Please contact your administrator.
        </Alert>
        <Button variant="contained" color="navy" onClick={onLogout}>
          Log out
        </Button>
      </Stack>
    </Box>
  );
}

export default OrganizationExpired;
